module.exports = __webpack_public_path__ + "img/text-icon.0525b3f7.svg";